module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "twsanomaly-globe.d4ec0aab.png";